import mount from "core/mount"
import { AdminSwitchUser } from "./switch-user"
import "./switch-user-button"

mount({ AdminSwitchUser })
